import { styled } from '@mui/system'
import * as React from 'react'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Stack, Typography } from '@mui/material';

const RootDiv = styled(Stack)({
})

const Styledsection = styled(Typography)({
	color: "#5a5852",
	display: "inline-block",
	textTransform: "uppercase",
	fontSize: "16px",
	fontWeight: "600",
})

export default function DotTitle (props) {
  return (
    <RootDiv direction="row" alignItems="center">
		<FiberManualRecordIcon sx={{color: "#E6142D"}}/>
		<Styledsection variant="body1">{props.section}</Styledsection>
    </RootDiv>
  )
}